import debounce from 'lodash/debounce';

export default {
  props: {
    vips: {
      type: Array,
      required: true,
    },

    initialSearch: {
      type: String,
      required: false,
      default: '',
    },

    highestVipPrice: {
      type: Number,
      required: true,
    },

    popularCategories: {
      type: Array,
      required: true,
    },

    categories: {
      type: Array,
      required: true,
    },

    initialFilter: {
      type: Object,
      required: false,
      default: () => {},
    },

    occasions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      filteredVips: this.vips,
      filteredVipsCount: this.vips.length,

      search: this.initialSearch || '',
    };
  },

  computed: {
    groupedVips() {
      return this.filteredVips
        .reduce((accumulator, vip, index) => {
          if (index % 12) {
            accumulator[accumulator.length - 1].push(vip);
          } else {
            accumulator.push([vip]);
          }

          return accumulator;
        }, []);
    },
  },

  created() {
    this.submitFilter = debounce(this.submitFilter, 100);
  },

  mounted() {
    this.$refs.vipsFilter.submitFilter(false, true);
  },

  methods: {
    filterRoute() {
      throw new Error('You must implement filterRoute method');
    },

    shouldDisplayVipsOccasions(currentIndex) {
      return currentIndex === 1 && this.groupedVips[currentIndex + 1]?.length > 0;
    },

    shouldDisplayVipsCategories(currentIndex) {
      return currentIndex === 0 && this.groupedVips[currentIndex + 1]?.length > 0;
    },

    resetFilter() {
      this.search = '';

      this.submitFilter();
    },

    recalculateFilter(filter) {
      let filteredVips = this.vips
        .filter((vip) => {
          if (!('search' in filter)) {
            return true;
          }

          const inDisplayName = vip.content.display_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(
              filter.search
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase(),
            );
          const inAbout = vip.content.about
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/<\/?[^>]+>/ig, ' ')
            .toLowerCase()
            .includes(
              filter.search
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase(),
            );
          return inAbout || inDisplayName;
        })
        .filter((vip) => {
          if (!('occasion' in filter)) {
            return true;
          }

          return Object.keys(vip.content.occasions).find((key) => vip.content.occasions[key].slug === filter.occasion);
        })
        .filter((vip) => {
          if (!('category' in filter)) {
            return true;
          }

          return Object.keys(vip.content.categories).find((key) => vip.content.categories[key].slug === filter.category);
        })
        .filter((vip) => {
          if (!('price_min' in filter)) {
            return true;
          }

          return vip.content.price >= filter.price_min * 100;
        })
        .filter((vip) => {
          if (!('price_max' in filter)) {
            return true;
          }

          return vip.content.price <= filter.price_max * 100;
        })
        .filter((vip) => {
          if (!('sort' in filter) || filter.sort !== 'within_2_days') {
            return true;
          }

          return vip.content.offers_48h === true;
        })
        .sort((a, b) => {
          switch (filter.sort) {
            case 'popular':
              return a.shout_outs_count > b.shout_outs_count ? -1 : 1;
            case 'price':
              return a.content.price - b.content.price;
            case 'newest':
              return b.created_timestamp - a.created_timestamp;
            case 'rating':
              return b.average_rating - a.average_rating;
            case 'speed':
              return a.average_delivery_time < b.average_delivery_time ? -1 : 1;
            default:
              return b.shout_outs_count - a.shout_outs_count;
          }
        });

      if (filter.sort !== 'popular' && filter.sort !== 'price' && filter.sort !== 'newest' && filter.sort !== 'rating' && filter.sort !== 'speed') {
        const positionedVips = [];
        filteredVips = filteredVips.filter((vip) => {
          if (vip.content.position) {
            positionedVips.push(vip);
            return false;
          }
          return true;
        });

        positionedVips.sort((a, b) => a.content.position - b.content.position);

        positionedVips.forEach((vip) => {
          const position = vip.content.position - 1;
          filteredVips.splice(position, 0, vip);
        });
      }

      this.filteredVipsCount = filteredVips.length;

      return filteredVips;
    },

    submitFilter(filter = {}, initial = false) {
      this.filteredVips = this.recalculateFilter(filter);

      if (!initial) {
        this.$inertia.get(this.filterRoute(), filter, {
          only: ['vips', 'initialSearch', 'initialFilter'],
          replace: false,
          preserveState: true,
          preserveScroll: true,
        });
      }
    },
  },
};
